import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    boolToBinary,
    checkNullArr,
    checkNullStr,
    createDeepCopy,
    createTimeout,
    deepObjectComparison,
    focusFormIdElement,
    getCurrUrlParamValue,
    getDefStr,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue
} from "../../common/fusion-ui/utils/ReactUtils";
import {getCategorizedModules, sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useNavigate} from "react-router-dom";
import {AdminModuleCtgs, AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType} from "../config/AdminConfig";
import {Checkbox, GridBox, Label, NullMsgLabel, RadioToggle, Section} from "../../common/fusion-ui";
import {CssVariant, Messages} from "../../common/fusion-ui/config/FusionConfig";
import {ThemedInput} from "../../common/components";
import {FormPageRoot} from "../components";
import {AnimationType, FramerAnimator} from "../../common/fusion-ui/animation/FramerAnimator";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const UserRole__AddEditFormPage = React.memo(({
                                                  updateOnly,
                                                  open,
                                                  onHide,
                                                  recordId,
                                                  showAs = ShowViewType.PAGE,
                                                  onSuccess,
                                              }) => {
    const TAG = "UserRole__AddEditFormPage";

    const moduleName = AdminModules.UserRoles;
    const mf = AdminModuleFieldsData[moduleName];

    const theme = useTheme();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const animator = new FramerAnimator();

    const categorizedModules = getCategorizedModules();

    const FOCUS_DELAY = 2000;
    const Fields = {
        updateRecordId: 'updateRecordId',

        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(UserRole__AddEditFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});
    // const [inputValue, setInputValue] = useState('');
    // const [reRenderCount, setReRenderCount] = useState(0);

    // log('Re-render-test:', reRenderCount);
    // useEffect(() => {
    //     setReRenderCount(reRenderCount + 1);
    // }, []);
    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
        }

        log('useEffect.showAs:', showAs, 'recordId:', recordId, 'updateOnly:', isUpdateMode());
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode()) {
                const id = getCurrUrlParamValue('id');
                log('useEffect.showAs:', showAs, 'id:', id);
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && (isUpdateMode())) {
                fetchEditModeData(recordId, false);
            }
        }
    }, [recordId, showAs, updateOnly]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            updateOnly={isUpdateMode()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            open={open}
            animateChildren={false}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData(true);
            }}
            showAs={showAs}
            md={12}
            panelMsg={getField(Fields.panelMsg)}
            panelMsgColor={getField(Fields.panelMsgColor)}
            isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
            isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
            onSubmit={handleSubmit}
            onPageRefresh={() => fetchEditModeData(getField(Fields.updateRecordId), false)}
        >
            <div className={''}>
                {/*name*/}
                {animator.setAnimationType(AnimationType.SLIDE_UP).setDuration(300).setDelay(10).render(
                    <GridBox className={'px-2'} md={4}>
                        <ThemedInput
                            className={''}
                            label={mf.name.title}
                            placeholder={mf.name.title}
                            id={mf.name.column}
                            value={getFormField(mf.name)}
                            // value={inputValue}
                            msg={getFormFieldMsg(mf.name)}
                            required={true}
                            type={'text'}
                            onChange={(e) => {
                                const value = e.target.value + '';
                                // setInputValue(value);
                                updateFormField(mf.name, value);
                                panelLog('');
                                if (checkNullStr(value)) updateFormFieldMsg(mf.name, '');
                            }}
                        />
                    </GridBox>
                )}

                {/*permission-modules*/}
                <div>
                    <Label className={`m-0 p-0 px-1 text-nowrap fw-bold text-input-label`}
                           required={true} color={theme.text40}>
                        {mf.permission.titleAlt}
                    </Label>

                    {/*module-cbs*/}
                    {animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(300).renderChildren(
                        <div>
                            {/*master-mgmt*/}
                            {renderPermSection({
                                ctg: AdminModuleCtgs.MasterMgmt,
                                modules: categorizedModules[AdminModuleCtgs.MasterMgmt],
                            })}

                            {/*activity-mgmt*/}
                            {renderPermSection({
                                className: 'mt-3',
                                ctg: AdminModuleCtgs.ActivityMgmt,
                                modules: categorizedModules[AdminModuleCtgs.ActivityMgmt],
                            })}

                            {/*res-mgmt*/}
                            {renderPermSection({
                                className: 'mt-3',
                                ctg: AdminModuleCtgs.ResourceMgmt,
                                modules: categorizedModules[AdminModuleCtgs.ResourceMgmt],
                            })}

                            {/*db-mgmt*/}
                            {renderPermSection({
                                className: 'mt-3',
                                ctg: AdminModuleCtgs.DatabaseMgmt,
                                modules: categorizedModules[AdminModuleCtgs.DatabaseMgmt],
                            })}
                        </div>
                    )}
                </div>

                {/*isActive*/}
                {isUpdateMode() && <div className={'mt-3'}>
                    <RadioToggle
                        radioClassName={'w-auto'}
                        labelColor={theme.text40}
                        binary={true}
                        required={true}
                        checked={boolToBinary(isFormFieldTrue(mf.status))}
                        config={{
                            label: mf.status.titleAlt,
                            active: "YES", inactive: "NO"
                        }}
                        onChange={(e, value) => {
                            log('status.onChange.value:', value);
                            updateFormField(mf.status, value);
                        }}
                    />
                </div>}
            </div>
        </FormPageRoot>
    </>)

    function renderPermSection({ctg, modules = [], className = ''}) {
        return <div className={`${className}`}>
            <Section
                className={`px-3 py-2 h-100 app-section hover`}
                titleClassName={'fs-md px-1'}
                title={ctg}
                borderColor={theme.text10}
                titleColor={theme.text}
                titleAt={'start'}
                overflow={'visible'}
                roundedVariant={4}>
                {/*{animator.setAnimationType(AnimationType.FADE_IN).setDuration(50).setEasing(EasingType.EASE_IN).renderChildren(*/}
                <div className={''}>
                    {/*select-all-cb*/}
                    <div className={'px-1x mt-1'}>
                        <Checkbox
                            wrapperClassName={'w-auto'}
                            labelColor={theme.text}
                            py={0}
                            // defaultChecked={(checkNullArr(getFormField(mf.permission)) && checkNullArr(modules)) && modules.every(item => getFormField(mf.permission).includes(item))}
                            // checked={(checkNullArr(getFormField(mf.permission)) && checkNullArr(modules)) && modules.every(item => getFormField(mf.permission).includes(item))}
                            // defaultChecked={(checkNullArr(getFormField(mf.permission)) && checkNullArr(modules) && (!modules.includes(AdminModules.Users) || !modules.includes(AdminModules.UserRoles))) && modules.every(item => getFormField(mf.permission).includes(item))}
                            // checked={(checkNullArr(getFormField(mf.permission)) && checkNullArr(modules) && (!modules.includes(AdminModules.Users) || !modules.includes(AdminModules.UserRoles))) && modules.every(item => getFormField(mf.permission).includes(item))}
                            onChange={(e, value) => {
                                const fun = 'modulePerms.cb-all.onChange:';
                                log(fun, 'value:', value, '|', isUpdateMode());
                                try {
                                    let orgModules = modules;
                                    // orgModules = checkNullArr(orgModules) ? JSON.parse(JSON.stringify(orgModules)) : [];
                                    orgModules = checkNullArr(orgModules) ? createDeepCopy(orgModules) : [];
                                    if (isUpdateMode()) {
                                        orgModules = orgModules.filter(item => (item != AdminModules.Users && item != AdminModules.UserRoles));
                                    }
                                    log(fun, 'permModules:', orgModules);

                                    if (checkNullArr(orgModules)) {
                                        let permModules = getFormField(mf.permission);
                                        permModules = checkNullArr(permModules) ? permModules : [];

                                        if (value) {
                                            //add orgModules
                                            permModules.push(...orgModules);
                                        } else {
                                            //remove orgModules
                                            permModules = permModules.filter(name => !orgModules.includes(name));
                                        }
                                        log(fun, 'permModules:', permModules);
                                        updateFormField(mf.permission, permModules);
                                    } else {
                                        toast("No models available in this category!", CssVariant.info);
                                    }
                                } catch (error) {
                                    logErr(fun, error);
                                    toast("Selection failed, please try again!", CssVariant.warning);
                                }
                            }}>
                            {'Select All'}
                        </Checkbox>
                    </div>

                    {/*cb-list*/}
                    <GridBox className={'px-2 mt-2'} md={4} gapY={0}>
                        {checkNullArr(modules)
                            ? modules.map((item, index) => {
                                // const item = (item + '').replace('Manage', '').trim();

                                return <div key={index + item} className={'d-flex w-auto mt-n2'}>
                                    <Checkbox
                                        wrapperClassName={'w-auto'}
                                        labelColor={theme.text}
                                        py={0}
                                        disabled={isUpdateMode() && (item == AdminModules.Users || item == AdminModules.UserRoles)}
                                        defaultChecked={checkNullArr(getFormField(mf.permission)) && (getFormField(mf.permission).includes(item))}
                                        checked={checkNullArr(getFormField(mf.permission)) && (getFormField(mf.permission).includes(item))}
                                        onChange={(e, value) => {
                                            const fun = 'modulePerms.map.cb.onChange:';
                                            try {
                                                let permModules = getFormField(mf.permission);
                                                permModules = checkNullArr(permModules) ? permModules : [];

                                                if (permModules.includes(item)) {
                                                    permModules = permModules.filter(name => name != item);
                                                } else {
                                                    permModules.push(item);
                                                }
                                                log(fun, item, 'value:', value, '\npermModules:', permModules);
                                                updateFormField(mf.permission, permModules);
                                            } catch (error) {
                                                logErr(fun, error);
                                                toast("Selection failed, please try again!", CssVariant.warning);
                                            }
                                        }}>
                                        {item + ''}
                                    </Checkbox>
                                </div>
                            })
                            : <NullMsgLabel className={'mt-n2x'}
                                            textAt={'start'} color={theme.text80}>
                                {"No modules available this category!"}
                            </NullMsgLabel>}
                    </GridBox>
                </div>
                {/*)}*/}
            </Section>
        </div>
    }

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__userRoles_addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData(true);
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");
                    setFormData({});
                    setFormFieldsMsgs({});

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__userRoles_fetchEditPageRecord,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: (async (fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                setFormData(fetchedFormData);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [mf.name, mf.permission,];

        let verified = false;
        let colField = {};
        for (const loopField of requiredFields) {
            const fieldValue = formData[loopField.column];
            if (deepObjectComparison(loopField, mf.permission) && !checkNullArr(getFormField(mf.permission))) {
                toast('Please select some modules!', CssVariant.danger);
                updateFormFieldMsg(loopField, 'Please select some modules!');
                return false;
            } else if (!checkNullStr(fieldValue)) {
                colField = loopField;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            const colTitle = getDefStr(colField.titleAlt, colField.title);
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colTitle}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }


    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }


    function clearPanelData(refetchAddFormData = false) {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
        if (isBoolTrue(refetchAddFormData) && showAs != ShowViewType.PAGE && !isUpdateMode()) {
            updateField(Fields.dataLoadingMsg, '');
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

//======================Util Functions end=====================
});
export default UserRole__AddEditFormPage;
